'use client';

import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const NewsletterSection = () => {
  return (
    <section className="section bg-primary text-white">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="mb-4 text-white text-3xl font-bold tracking-tight">
              Get Job Updates
            </h2>
            <p className="text-primary-foreground/90 text-lg mb-6 leading-relaxed">
              Subscribe to our newsletter and be the first to know about new job
              opportunities, career advice, and exclusive events.
            </p>

            <div className="max-w-md">
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="relative flex-1 group">
                  <div className="absolute left-3 top-1/2 transform -translate-y-1/2 transition-colors duration-200">
                    <Mail className="h-5 w-5 text-white/50 group-hover:text-white/70 group-focus-within:text-white" />
                  </div>
                  <Input
                    type="email"
                    placeholder="Enter your email"
                    className="pl-10 bg-white/10 border-white/20 text-white placeholder:text-white/60 hover:border-white/40 focus:border-white/60 focus-visible:ring-2 focus-visible:ring-white/20 transition-colors duration-200"
                  />
                </div>
                <Button
                  variant="secondary"
                  className="flex items-center gap-2 font-semibold hover:bg-white hover:text-primary transition-colors duration-200"
                >
                  Subscribe
                  <ArrowRight className="h-4 w-4" />
                </Button>
              </div>
              <p className="text-sm text-primary-foreground/70 mt-3">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </div>
          </div>

          <div className="hidden md:block relative">
            <div className="absolute top-0 left-0 w-32 h-32 bg-blue-400/20 rounded-full blur-2xl"></div>
            <div className="absolute bottom-10 right-10 w-24 h-24 bg-blue-300/20 rounded-full blur-2xl"></div>
            <div className="relative z-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-10 shadow-elevation backdrop-blur-sm">
              <div className="mb-6 relative">
                <div className="absolute inset-0 bg-white/10 rounded-full blur-xl"></div>
                <Mail className="h-12 w-12 text-white relative z-10" />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3 tracking-tight">
                Weekly Job Digest
              </h3>
              <p className="text-primary-foreground/90 mb-6 leading-relaxed">
                Get personalized job recommendations and stay ahead in your
                career journey with our curated weekly digest.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-3 text-sm text-primary-foreground/90">
                  <div className="w-2 h-2 rounded-full bg-white"></div>
                  <span>Tailored job matches</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-primary-foreground/90">
                  <div className="w-2 h-2 rounded-full bg-white"></div>
                  <span>Industry insights</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-primary-foreground/90">
                  <div className="w-2 h-2 rounded-full bg-white"></div>
                  <span>Career growth tips</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
